module.exports = __webpack_public_path__ + "img/container-1.4e7a06df.png";